import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Product } from 'src/app/_model/product';
import { ProductService } from 'src/app/_services/product-service.service';
import { enableLogging, environment } from '../../../environments/environment';
import { Location, ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state(
        'void',
        style({
          opacity: 0,
        })
      ),
      transition('void <=> *', animate(1000)),
    ]),
  ],
})
export class HomePageComponent implements OnInit {
  product;
  relatedProducts: Product[] = [];
  showLoading = true;
  route: string;
  productName: string;

  constructor(
    private productService: ProductService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: Location,
    private viewportScroller: ViewportScroller
  ) {
    // router.events.subscribe(val => {
    //   console.log('val',val);
    //   console.log('(this.location.path() ',location.path() );
    //   if (location.path() != "") {
    //     this.route = location.path();
    //   } else {
    //     this.route = "Home";
    //   }
    // });
  }

  ngOnInit(): void {
    this.productService.sameProductPressed.subscribe((res) => {
      this.getProduct(res);
    });
    // this.showLoading = true;
    // console.log( window.location.hostname);
    // console.log('root',    this.activatedRoute.   );

    // TODO  ---> use this on production
    // if (environment.production) {
    // console.log('env');

    this.productName = window.location.hostname.split('.')[0];
    this.getProduct(this.productName);

    this.activatedRoute.fragment.subscribe((fragment) => {
      if (fragment) {
        this.viewportScroller.scrollToAnchor(fragment);
      }
    });
    // }
    //TODO ---------------------------------------

    // !  ---- > use this for testing < -------
    // this.router.events.subscribe((val) => {
    //   console.log('val', val);
    //   console.log('(this.location.path() ', this.location.path());

    //   if (this.location.path() != '') {
    //     this.route = this.location.path();
    //   } else {
    //     this.route = 'Home';
    //   }
    // });

    // this.activatedRoute.params.subscribe(
    //   (res) => {
    //     this.showLoading = true;
    //     // console.log(res);

    //     this.productService.getProductByName(res.name).subscribe((response) => {
    //       // console.log(response);

    //       this.product = this.productMapper(response);
    //       this.product.relatedProducts &&
    //         this.product.relatedProducts.length > 0 &&
    //         this.product.relatedProducts.map((prod) => {
    //           // console.log(prod.relatedProductNavigation);

    //           this.productService
    //             .getProductByName(
    //               prod.product
    //                 ? prod.product.name
    //                 : prod.relatedProductNavigation.name
    //             )
    //             .subscribe((res) => {
    //               this.relatedProducts.push(this.productMapper(res));
    //             });
    //         });

    //       this.showLoading = false;

    //       // enableLogging && console.log(this.product);

    //       // enableLogging && console.log(this.relatedProducts);
    //     });

    //     if (!this.product) {
    //       this.router.navigateByUrl('/not-found');
    //     }
    //   },
    //   () => {},
    //   () => {}
    // );

    // !  ---- > use this for Production < -------

    document.addEventListener('scroll', (e) => {
      if (window.scrollY > 30) {
        document.getElementById('top-nav').classList.add('scroll');
        document.getElementById('main-section').classList.add('pad');
      } else if (window.scrollY == 0) {
        document.getElementById('top-nav').classList.contains('scroll') &&
          document.getElementById('top-nav').classList.remove('scroll');

        document.getElementById('main-section').classList.contains('pad') &&
          document.getElementById('main-section').classList.remove('pad');
      }
    });
  }

  ngDoCheck() {
    if (this.productName != window.location.hostname.split('.')[0]) {
      this.productName = window.location.hostname.split('.')[0];
      // this.getProduct();
    }
  }

  productMapper(backEndProduct) {
    const video = backEndProduct['productImages'].find(
      (item) => item.name == 'video'
    );
    const image = backEndProduct['productImages'].find(
      (item) => item.name == 'productImage'
    );
    const frontViewImage = backEndProduct['productImages'].find(
      (item) => item.name == 'relatedProductImage'
    );

    const forms = backEndProduct['productForms'].map((form) => {
      return {
        type: form.form.name,
        concentration: form.productFormValues.map((cons) => cons.concentration),
      };
    });

    const trials = backEndProduct['productTrials'].map((trial) => {
      return {
        trialName: trial.name,
        trialText: trial.description,
        trialGraphUrl: trial && trial.imageUrl,
        // pdfUrl: trial.pdfurl,
        imageUrl: trial.imageUrl
      };
    });

    const guidelines = backEndProduct['productGuidelines'].map((guid) => {
      return {
        guidelineUrl: guid.pdfurl,
        guidelineText: guid.description,
      };
    });

    const indications = backEndProduct['productDoses'].map((ind) => {
      const doses = ind.productDosesValues.map((dos) => {
        return {
          dose: dos.name,
        };
      });
      return {
        indication: ind.name,
        doses: doses,
      };
    });
    console.log(trials,'trials')
    return {
      id: backEndProduct['id'],
      productName: backEndProduct['name'],
      productSlogan: backEndProduct['slogan'],

      keyMessage: backEndProduct['productKeyMessags'],
      imageUrl: image && image.imageUrl,
      frontViewImageUrl: frontViewImage && frontViewImage.imageUrl,
      activeIngredient: backEndProduct['activeIngredientTitle'],
      activeIngredientsDetails: backEndProduct['activeIngredientDescription'],
      videoUrl: video && video.imageUrl,
      forms: forms,
      indications: indications,
      interactions: backEndProduct['productInteractions'].map(
        (interaction) => interaction.name
      ),
      trial: trials,
      guidelines: guidelines[0],
      relatedProducts: backEndProduct['relatedProductProducts'],
      domain: backEndProduct['domain'],
      linkUrL:
        backEndProduct.linkUrL && backEndProduct.linkUrL.startsWith('http')
          ? backEndProduct.linkUrL
          : 'https://' + backEndProduct.linkUrL,
      linkMessage: backEndProduct.linkMessage,
      registerButton: backEndProduct.registerButton,
      variations: backEndProduct.sameFamilyProductProducts,
      productReferences: backEndProduct.productReferences,
    };
  }

  getProduct(productName) {
    // console.log(this.productName);

    this.productService
      .getProductBySubDomain(productName)
      .subscribe((response) => {
        // console.log(response);

        this.product = this.productMapper(response);
        this.showLoading = false;

        this.product.relatedProducts &&
          this.product.relatedProducts.length > 0 &&
          this.product.relatedProducts.map((prod) => {
            if (
              !prod.relatedProductNavigation?.deleted ||
              !prod.product?.deleted
            ) {
              // console.log(prod.relatedProductNavigation);
              this.showLoading = true;

              this.productService
                .getProductByName(
                  prod.product
                    ? prod.product.name
                    : prod.relatedProductNavigation.name
                )
                .subscribe((res) => {
                  console.log('hnaaa', this.relatedProducts);

                  !this.relatedProducts.includes(this.productMapper(res)) &&
                    this.relatedProducts.push(this.productMapper(res));
                  this.showLoading = false;
                });
            }
          });

        // this.product = this.productService.getProductByName(this.productName);
        //   enableLogging && console.log(this.product);
        //   this.relatedProducts =
        //   this.product.relatedProducts && this.product.relatedProducts.length > 0 &&
        //     this.productService.getRelatedProducts(this.product.id);
        //   enableLogging && console.log(this.relatedProducts);
        //   setTimeout(() => {
        //     this.showLoading = false;
        //   }, 1000);
        // }
      });
  }
}
